import { map, sum } from 'lodash';
import { DurationRead } from 'app/components/Duration/Duration';
import { getResources } from 'app/store/selectors/getResources.js';
export const getTaskTimeEstim = (state, taskId) => {
    const task = getResources(state, 'tasks', taskId, ['takesInst']);
    const timeEstim = sum(map(task.takesInst, (take) => take.estimLength));
    return DurationRead({ value: timeEstim });
};
